<template>
  <v-dialog 
    :value="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card>
      <v-card-title class="d-flex justify-content-center pt-10">Não podemos gerar o relatório ril por este motivo:</v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <h6 class="text-center mt-5">{{ msgAlert }}</h6>
      </v-card-text>
      <v-card-actions class="pt-0 pb-10">
        <div class="col-12 d-flex justify-content-center">
          <v-btn
            outlined class="btn-back"
            @click="$emit('close')"
          >
            Voltar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalError",
  props: {
    active: Boolean,
    msgAlert: String
  }
}
</script>
